import Delete from "assets/Icon_Action_03.png";
import Update from "assets/Icon_Action_02.png";
import View from "assets/Icon_Action_01.png";
import { lazyWithRetry } from "helpers/lazyWithRetry";
import { CountriesRow } from "./CountriesList.types";
import DeleteModal from "components/helpers/DeleteModal";
import { CrudItems, CrudOptions } from "components/Category/CrudMenu";
import { endpoints } from "config";

const Country = lazyWithRetry(() => import("pages/Countries/Country/Country"));

// --- CRUD item creators ---

/**
 * Creates the create menu item for Countries.
 * @returns CRUD item for creating a new country.
 */
function createCountryCreateItem() {
  return {
    icon: View,
    imgAltText: "Create",
    permissionsKey: "create",
    title: "Add new country",
    menuCode: "CREATE" as CrudOptions,
    showInMultiSelect: false,
    content: (onDone: () => void, selectedData: CountriesRow[], menu: any) => (
      <Country
        selectedData={selectedData}
        onDone={onDone}
        idFromRowOption={menu.selectedId}
        actionType="create"
        submitButtonText="Add"
      />
    ),
    inRightPanel: true,
    isDisabled: false,
    notInMenus: true,
  };
}

/**
 * Creates the update menu item for Countries.
 * @returns CRUD item for updating an existing country.
 */
function createCountryUpdateItem() {
  return {
    icon: Update,
    imgAltText: "Update",
    permissionsKey: "edit",
    title: "Update country",
    menuCode: "UPDATE" as CrudOptions,
    showInMultiSelect: false,
    content: (onDone: () => void, selectedData: CountriesRow[], menu: any) => (
      <Country
        selectedData={selectedData}
        onDone={onDone}
        idFromRowOption={menu.selectedId}
        actionType="edit"
        submitButtonText="Update"
      />
    ),
    inRightPanel: true,
    isDisabled: false,
  };
}

/**
 * Creates the delete menu item for Countries.
 * @returns CRUD item for deleting one or more countries.
 */
function createCountryDeleteItem() {
  return {
    icon: Delete,
    imgAltText: "Delete",
    permissionsKey: "delete",
    title: (data: CountriesRow[]) =>
      data.length <= 1 ? "Delete country" : `Delete ${data.length} countries`,
    menuCode: "DELETE" as CrudOptions,
    showInMultiSelect: true,
    content: (onActionComplete: () => void, selectedData: CountriesRow[], menu: any) => (
      <DeleteModal
        url={endpoints.countries.delete}
        noun="country"
        selectedIds={selectedData.map((d) => d.countries__Id)}
        renderListItem={(data: CountriesRow) => {
          return <li>{`${data.countries__Id}: ${data.countries__DisplayValue}`}</li>;
        }}
        selectedData={selectedData}
        open={menu.currentMenu === "DELETE"}
        close={onActionComplete}
        idFromRowOption={menu.selectedId}
      />
    ),
    inRightPanel: false,
    isDisabled: false,
  };
}

/**
 * Gets all CRUD items for Countries.
 * @returns Array of CRUD items for country operations.
 */
export function getCrudItems(): CrudItems<CountriesRow> {
  return [
    createCountryCreateItem(),
    createCountryUpdateItem(),
    createCountryDeleteItem(),
  ];
}
